import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { CmsModule } from '@fcom/cms';
import { ComponentsModule, DirectiveModule, FinFormsModule, NavigationModule, PipesModule } from '@fcom/common';
import { LoginModule } from '@fcom/common/login';
import { CommonBookingComponentsModule } from '@fcom/common-booking';
import { UiTranslateModule } from '@fcom/ui-translate/ui-translate.module';
import { UiComponentsModule } from '@fcom/ui-components';
import { ConfigService } from '@fcom/core';

import { TimetableRoutingComponent } from './components/timetable-routing/timetable-routing.component';
import { TimetableRoutesModule } from './timetable.routes';
import { TIMETABLE_FEATURE_KEY } from './constants';
import { reducers } from './store/reducers';
import { TimetableComponent } from './components/timetable/timetable.component';
import { TimetableSearchComponent } from './components/timetable-search/timetable-search.component';
import { TimetableCalendarComponent } from './components/timetable-calendar/timetable-calendar.component';
import { TimetableScheduleComponent } from './components/timetable-schedule/timetable-schedule.component';
import { LocationSearchComponent } from './components/location-search/location-search.component';
import { TimetableSearchService } from './services/timetable-search.service';
import { SeasonalNotificationComponent } from './components/seasonal-notification/seasonal-notification.component';
import { DataEffects } from './store/effects/index';
import { TimetableLocationsService } from './services/timetable-locations.service';

@NgModule({
  imports: [
    CommonModule,
    ComponentsModule,
    CommonBookingComponentsModule,
    NavigationModule,
    TimetableRoutesModule,
    LoginModule,
    CmsModule,
    ComponentsModule,
    PipesModule,
    UiTranslateModule,
    UiComponentsModule,
    PipesModule,
    UiComponentsModule,
    MatAutocompleteModule,
    ReactiveFormsModule.withConfig({
      callSetDisabledState: 'whenDisabledForLegacyCode',
    }),
    FinFormsModule,
    DirectiveModule,
    StoreModule.forFeature(TIMETABLE_FEATURE_KEY, reducers),
    EffectsModule.forFeature([DataEffects]),
  ],
  declarations: [
    TimetableRoutingComponent,
    TimetableComponent,
    TimetableSearchComponent,
    TimetableCalendarComponent,
    TimetableScheduleComponent,
    LocationSearchComponent,
    SeasonalNotificationComponent,
  ],
  providers: [TimetableSearchService, TimetableLocationsService, ConfigService],
  exports: [],
})
export class TimetableModule {}
